import { BuilderKeyMap } from "../build/BuilderKeyMap";
import { BaseLayer } from "../build/types";
import { ActionCallbacks } from "../components/BuilderInterface";
import HookWrapper from "../components/HookWrapper";

const getDataObjId = (dataObj: any) => {
    if (typeof dataObj._id !== "string") {
        return dataObj?._id?.$oid;
    }

    return dataObj._id;
};

export const renderRepeaterDiv = <T,>(config: {
    baseLayer: BaseLayer;
    nodeKey: string;
    dataObj: any;
    defaultCallback: (entity: T) => void;
    index: number;
    actionCallbacks?: Record<string, ActionCallbacks>;
    textSettings?: any;
    extraProps?: any;
    activeItemId?: string;
    formatCurrency?: (amount: number) => string;
}): React.ReactNode => {
    const {
        baseLayer,
        nodeKey,
        dataObj,
        defaultCallback,
        index,
        actionCallbacks,
        textSettings,
        extraProps,
        activeItemId,
        formatCurrency
    } = config;

    if (!nodeKey)
        return renderRepeaterDiv({
            baseLayer,
            nodeKey: baseLayer.root,
            dataObj,
            defaultCallback,
            index,
            actionCallbacks,
            textSettings,
            activeItemId,
            formatCurrency
        });

    const node = baseLayer.components[nodeKey];

    const callback = (e: React.MouseEvent, entity: T) => {
        e.stopPropagation();

        defaultCallback(entity);

        const action = actionCallbacks?.[node.id]?.onClick;

        if (typeof action === "function") {
            action();
        }
    };

    if (node) {
        const Component = BuilderKeyMap[node.name as keyof typeof BuilderKeyMap];
        if (Component) {
            return (
                <HookWrapper
                    component={Component}
                    actionCallbacks={
                        actionCallbacks?.[node.id] || node.name === "repeaterDiv"
                            ? { onClick: (e: React.MouseEvent) => callback(e, dataObj) }
                            : undefined
                    }
                    node={node}
                    key={`${node.id}-${index}`}
                    dataObject={dataObj}
                    textSettings={textSettings}
                    layer={baseLayer}
                    {...extraProps}
                    selected={node.name === "repeaterDiv" && activeItemId === getDataObjId(dataObj)}
                    formatCurrency={formatCurrency}
                >
                    {node.children &&
                        node.children.map(nodeId => {
                            return renderRepeaterDiv({
                                baseLayer,
                                nodeKey: nodeId,
                                dataObj,
                                defaultCallback,
                                index,
                                actionCallbacks,
                                textSettings,
                                activeItemId,
                                formatCurrency
                            });
                        })}
                </HookWrapper>
            );
        }
    }
};
